<template>
    <div>
      <Splide :has-track="false" class="splide__gallery" :options="options" @splide:move="loadAllSlides">
        <SplideTrack>
            <SplideSlide
                v-for="(item, index) in gallery" :key="item.id"
                class="overflow-hidden"
            >
                <picture
                    class="w-full select-none"
                    width="480"
                    height="480"
                    v-if="item.url"
                >
                    <source
                    :srcset="`
                        ${item.url}?tr=w-1920,
                        ${item.url}?tr=w-3840 2x
                    `"
                    media="(min-width:1480px)"
                    />
                    <source
                    :srcset="`
                        ${item.url}?tr=w-1480,
                        ${item.url}?tr=w-2960 2x
                    `"
                    media="(min-width:1000px)"
                    />
                    <!-- Whole photos, cropped once here around their focus point. On phones the box is square, so
                         the photo shows at about 1.5 times the screen's width -->
                    <img class="h-full xl:h-[600px] w-full xl:rounded-3xl object-cover aspect-square sm:aspect-auto"
                        :loading="index === 0 ? 'eager' : 'lazy'" :src="`${item.url}?tr=w-700`"
                        :srcset="`${item.url}?tr=w-700 700w, ${item.url}?tr=w-1000 1000w, ${item.url}?tr=w-1400 1400w, ${item.url}?tr=w-2200 2200w`"
                        :style="{ objectPosition: item.focus }"
                        sizes="(min-width: 640px) 100vw, 150vw" :alt="`${item.alt} image`">
                </picture>
            </SplideSlide>
        </SplideTrack>

        <div class="splide__arrows absolute sm:top-1/2 xl:top-auto xl:-bottom-16 left-0 flex justify-between w-full xl:w-auto gap-2 px-4 xl:px-0">
          <button class="splide__arrow--prev w-11 h-11 flex justify-center items-center bg-primary hover:bg-primary-tone rounded-full transition-all duration-200">
              <svg class="relative -left-px" width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.22748 8.80219L2.37798 15.6517C1.94989 16.1155 1.20072 16.1155 0.772631 15.6517C0.308863 15.2236 0.308863 14.4744 0.772631 14.0463L6.80162 7.98167L0.772631 1.95269C0.308863 1.5246 0.308863 0.775431 0.772631 0.347338C1.20072 -0.11643 1.94989 -0.11643 2.37798 0.347338L9.22748 7.19684C9.69125 7.62493 9.69125 8.37409 9.22748 8.80219Z" fill="#3B3C4A"/>
              </svg>
          </button>

          <button class="splide__arrow--next w-11 h-11 flex justify-center items-center bg-primary hover:bg-primary-tone rounded-full transition-all duration-200">
              <svg class="relative -right-px" width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.22748 8.80219L2.37798 15.6517C1.94989 16.1155 1.20072 16.1155 0.772631 15.6517C0.308863 15.2236 0.308863 14.4744 0.772631 14.0463L6.80162 7.98167L0.772631 1.95269C0.308863 1.5246 0.308863 0.775431 0.772631 0.347338C1.20072 -0.11643 1.94989 -0.11643 2.37798 0.347338L9.22748 7.19684C9.69125 7.62493 9.69125 8.37409 9.22748 8.80219Z" fill="#3B3C4A"/>
              </svg>
          </button>
        </div>
      </Splide>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import ResponsiveMixin from "./../mixins/responsive"

export default defineComponent({
  components: {
    Splide,
    SplideSlide,
    SplideTrack,
  },
  mixins: [ResponsiveMixin],
  props: {
    type: {
      type: String,
      default: "text_left",
    },
  },
  computed: {
    gallery() {
      return window?.capes?.hero_gallery ?? {}
    },
  },
  data() {
    return {
      options: {
        pagination: false,
        arrows: true,
        type : 'loop',
        perMove: 1,
        type: 'loop',
        breakpoints: {
          768: {
              arrows: false,
              pagination: true,
          },
        },
      },
    }
  },
  methods: {
    // Only the first slide loads with the page. Once someone moves the carousel, load the rest
    // so the next slides are ready. Splide's loop clones aren't Vue's, so this goes via the DOM
    loadAllSlides(splide) {
      splide.root.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        img.loading = 'eager'
      })
    },
  },
});
</script>